import React, { useState, useEffect, useContext } from 'react';

import Fr_Input from "../../../lib/ui/fr_input";
import * as net from "../../../lib/net";
import Dd_Sel from "../../../lib/ui/dd_sel";
import Scr_Base from "./tv_split";
import Scr_Split from "./tv_split";
import Scr_VSplit from "./tv_split";
import Scr_HSplit from "./tv_split";
import Scr_ColFlow from "./tv_colflow";

class Scr_TvDemo extends React.Component {
  constructor(props, context) {
    super(props);

    this.store = props.store;
    //this.pos = props.store.pos;

    this.state = {};
    this.state.today = new Date();
    this.state.rta = [];
    this.state.pka = [];

      this.state.tvid = "1";
      this.state.scrid = "tv01";
    this.state.gso = {};

    this.state.ynq = [
                {id: '0', text: 'NEJ'},
                {id: '1', text: 'JA'}
            ];

      this.state.screens = [
          {scrid: 'tv01', text: 'TV 01'},
          {scrid: 'tv02', text: 'TV 02'},
          {scrid: 'tv03', text: 'TV 03'},
          {scrid: 'tv04', text: 'TV 04'}
      ];
      this.state.sca = [];

      this.state.resolution = [
          { id: 'vga', text: 'VGA', w: "1024px", h: "768px" },
          { id: 'hd', text: 'HD Ready 720p', w: "1280px", h: "720px" },
          { id: 'fhd', text: 'FULL HD 1080p', w: "1920px", h: "1080px" },
          { id: 'qhd', text: 'QHD', w: "2560px", h: "1440px" },
          { id: '4k', text: '4K', w: "3840px", h: "2160px" },
          { id: '8k', text: '8K', w: "7680px", h: "4320px" }
      ];
      this.state.tv_width = "1280px";
      this.state.tv_height = "720px";

    this.state.rs = "";
    this.state.tbo = {};
    this.state.background = "#fff";

      //this.state.vsrc = "http://filpub.svepos.se/menytv/tradgard/trad01.mp4";
      this.state.vsrc = "";
    this.state.wnds = {};
    if(props.wnds) {
        this.state.tvid = props.wnds.tvid;
    }
      var tvo = {};
      tvo.data = {};

      tvo.data.c11 = {};
      tvo.data.c11.mnu = {};
      tvo.data.c11.mnu.text = "T11";
      tvo.data.c11.mnu.rows = [];
      tvo.data.c11.mnu.descrows = [];

      tvo.data.c12 = {};
      tvo.data.c12.mnu = {};
      tvo.data.c12.mnu.text = "T12";
      tvo.data.c12.mnu.rows = [];
      tvo.data.c12.mnu.descrows = [];

      tvo.data.c21 = {};
      tvo.data.c21.mnu = {};
      tvo.data.c21.mnu.text = "T21";
      tvo.data.c21.mnu.rows = [];
      tvo.data.c21.mnu.descrows = [];

      tvo.data.c22 = {};
      tvo.data.c22.mnu = {};
      tvo.data.c22.mnu.text = "T22";
      tvo.data.c22.mnu.rows = [];
      tvo.data.c22.mnu.descrows = [];
      //var tvo = props.store.tvo;
      this.state.tvo = tvo;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKey);
  }
  componentDidMount() {
    document.addEventListener("keydown", this.handleKey);

      //this.init_tv();
      this.dsi_screens();
  }

    handleKey = (e) => {
        e.preventDefault();
        //alert(e.key);
        //alert(e.code);
        if(this.state.wnds.tvcfg == true) return;

        if(e.keyCode == 13) {
            //alert("ENTER MNU");
            this.tv_cfg();
        }
        if(e.keyCode == 112) {
            //alert("F1");
        }
        if(e.keyCode == 113) {
            //alert("F2");
            //this.sz();
        }
        if(e.keyCode == 114) {
            //alert("F3");
        }
        if(e.keyCode == 115) {
            //alert("F4");
        }
        if(e.keyCode == 116) {
            //alert("F5");
        }
        if(e.keyCode == 117) {
            //alert("F6");
        }
        if(e.keyCode == 118) {
            //alert("F7");
        }
        if(e.keyCode == 119) {
            //alert("F8");
        }
        if(e.keyCode == 120) {
            //alert("F9");
        }
        if(e.keyCode == 121) {
            //alert("F10");
        }
        //if(e.keyCode == 122) {alert("F11");} // NOT TRAPPABLE
        if(e.keyCode == 123) {
            //alert("F12");
        }
    }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    wnd_close = () => {
      if(this.props.cb) {
        var ret = {};
        ret.ok = "999";
        this.props.cb(this.props.ctx, ret);
      }
      else this.props.ctx.setState({ wnds: {} });
	};

    show_mnu() {
        return "true";
    }
    css_bg(tvo) {
        var css = {};
        css.position = "absolute";
        css.width = "100%";
        css.height = "100%";
        css.background = "#000";
        css.overfow = "hidden";
        css.zIndex = "-99";
        if(tvo.bg && tvo.bg.bgfarg) {
            if(tvo.bg.bgfarg.length > 0) css.background = tvo.bg.bgfarg;
        }
        return css;
    }
    css_desc() {
        var css = {};
        return css;
    }
    css_category() {
        var css = {};
        return css;
    }
    css_row_text() {
        var css = {};
        return css;
    }
    css_row_price() {
        var css = {};
        return css;
    }
    css_row_desc() {
        var css = {};
        css.width = "80%";
        return css;
    }
    price_text(row) {
        var belopp = row.pris.dec2();
        //belopp = moment().subtract(1, "days").format("YYYY-MM-DD");
        if(belopp) {
            if(belopp.trim().length > 0) belopp = belopp + " kr";
        }
        if(row.type == "INFO") belopp = "";
        return belopp;
    }

    tvo_poll() {
        var self = this;
        setInterval(function(){
            var req = {};
            req.tvid = "tv03";
            req.tid = "";
            req.ip = "";

            //alert(JSON.stringify(req));
            //self.get_tvo();
            //console.log("REQ SENT : " + util.inspect(req.fkn));
        }, 5000);
    }
    init_bg(farg) {
        var self = this;
        var bg = document.getElementById("myBg");
        bg.style.opacity = "1.0";
        bg.style.background = farg;
    }
    init_tv(src) {
        var self = this;
        //alert(JSON.stringify(src));
        //self.dsi();
        //self.get_tvo();
        //self.tvo_poll();
        var video = document.getElementById("myVideo");
        var mp4 = document.getElementById("mp4");
        //mp4.src = this.state.vsrc;
        mp4.src = src;

        video.load();
        video.play();
        //if (video.paused) {
        //    video.play();
        //}
    }
    dsi_screens() {
        var self = this;
        var prm = {};
        prm.req = "dsi.dsi_scr.scr_list";

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret.rca));

                self.setState({ sca: ret.rca }, function() {
                    //self.syncTb("scrTable");
                });
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    dsi() {
        var self = this;
        var prm = {};
        prm.req = "dsi.dsi_run.tv_lt";
        //prm.sid = "S0000099";
        prm.scrid = this.state.scrid;
        //prm.scrid = "tv01";

        //alert(JSON.stringify(prm));
        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret.rco));

                var tvo = ret.rco;
                var cta = ret.rca;
                //alert(JSON.stringify(tvo));

                if(!tvo.data.c11.mnu.descrows) tvo.data.c11.mnu.descrows = [];
                if(!tvo.data.c12.mnu.descrows) tvo.data.c12.mnu.descrows = [];
                if(!tvo.data.c21.mnu.descrows) tvo.data.c21.mnu.descrows = [];
                if(!tvo.data.c22.mnu.descrows) tvo.data.c22.mnu.descrows = [];
                if(!tvo.data.c11.mnu.rows) tvo.data.c11.mnu.rows = [];
                if(!tvo.data.c12.mnu.rows) tvo.data.c12.mnu.rows = [];
                if(!tvo.data.c21.mnu.rows) tvo.data.c21.mnu.rows = [];
                if(!tvo.data.c22.mnu.rows) tvo.data.c22.mnu.rows = [];
                self.setState({ tvo: tvo }, function() {
                    //if(tvo.bg.bgfarg && tvo.bg.bgfarg.length) self.init_bg(tvo.bg.bgfarg);
                    if(tvo.bg && (tvo.bg.bgtyp == "3")) {
                        //alert(JSON.stringify(tvo.bg.bgtyp));
                        //if(tvo.bg.bgurl && tvo.bg.bgurl.length) self.init_tv(tvo.bg.bgurl);
                    }
                    //alert(JSON.stringify(tvo.cttyp));
                    if((tvo.cttyp == "rut4") || (tvo.cttyp == "rut6")) {
                        var wnds = {};
                        wnds.split = true;
                        wnds.tvo = tvo;
                        wnds.cta = cta;
                        wnds.tv_width = self.state.tv_width;
                        wnds.tv_height = self.state.tv_height;
                        self.setState({"wnds": wnds});
                    }
                    if((tvo.cttyp == "ver2") || (tvo.cttyp == "ver3")) {
                        var wnds = {};
                        wnds.vsplit = true;
                        wnds.tvo = tvo;
                        wnds.cta = cta;
                        wnds.tv_width = self.state.tv_width;
                        wnds.tv_height = self.state.tv_height;
                        self.setState({"wnds": wnds});
                    }
                    if((tvo.cttyp == "hor2") || (tvo.cttyp == "hor3")) {
                        var wnds = {};
                        wnds.hsplit = true;
                        wnds.tvo = tvo;
                        wnds.cta = cta;
                        wnds.tv_width = self.state.tv_width;
                        wnds.tv_height = self.state.tv_height;
                        self.setState({"wnds": wnds});
                    }
                    if((tvo.cttyp == "col2") || (tvo.cttyp == "col3")) {
                        var wnds = {};
                        wnds.colflow = true;
                        wnds.tvo = tvo;
                        wnds.cta = cta;
                        wnds.tv_width = self.state.tv_width;
                        wnds.tv_height = self.state.tv_height;
                        self.setState({"wnds": wnds});
                    }
                    if((tvo.cttyp == "base") || (tvo.cttyp == "")) {
                        var wnds = {};
                        wnds.base = true;
                        wnds.tvo = tvo;
                        wnds.cta = cta;
                        wnds.tv_width = self.state.tv_width;
                        wnds.tv_height = self.state.tv_height;
                        self.setState({"wnds": wnds});
                    }
                });
                //toastr.success("OK", "SAPI");
                //self.set_tvo(tvo);
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    sel_screen(sel) {
        var self = this;
        //alert(JSON.stringify(fkn));
        this.setState({"scrid": sel.scrid}, function() {
            self.dsi();
        });
        if(sel.scrid !== "xx") {
        }
    }
    sel_resolution(sel) {
        //alert(JSON.stringify(fkn));
        this.setState({"tv_width": sel.w, "tv_height": sel.h});
    }

  render() {
    //if(!this.props.show) return "";

    var title = this.props.title;
    if(!title) title = "Gäst";
    //if(props.kro) alert(props.kro.krr00.kid);
    var tvo = this.state.tvo;

      // https://drive.google.com/file/d/1SjJ9fdfPaqEgdsTvYN78pE-XGKJOSHA_/view?usp=drive_web
      // <source src="http://filpub.svepos.se/menytv/tradgard/trad01.mp4" type="video/mp4" />

	var html =
        <div className="mx_base">
        <div className="m3_backdrop" />
        <div className="m3_dlg mx_100 flex-col" style={ this.dlg_style() } >

        <div className="mx_h01">
            <div>TVM</div>
            <div className="flex"></div>
            <div>{ this.state.scrid }</div>
            <div className="flex"></div>
        </div>

        <div className="mx_content flex">

            { this.state.wnds.split ? <Scr_Split wnds={this.state.wnds} store={this.store} ctx={this} /> : null}
            { this.state.wnds.split ? <Scr_VSplit wnds={this.state.wnds} store={this.store} ctx={this} /> : null}
            { this.state.wnds.split ? <Scr_HSplit wnds={this.state.wnds} store={this.store} ctx={this} /> : null}
            { this.state.wnds.colflow ? <Scr_ColFlow wnds={this.state.wnds} store={this.store} ctx={this} /> : null}
            { this.state.wnds.base ? <Scr_Base wnds={this.state.wnds} store={this.store} ctx={this} /> : null}

        </div>

        <div className="mx_foot flex-row">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                AVBRYT
            </button>
            <div className="flex"></div>
            <Dd_Sel items={ this.state.sca } getValue={(e)=> this.sel_screen(e)} />
            <div className="flex"></div>
            <Dd_Sel items={ this.state.resolution } getValue={(e)=> this.sel_resolution(e)} />
            <button className="btn btn-hw-red w250 hide" onClick={() => this.dsi() } >
                { this.state.res }
            </button>
            <div className="flex"></div>
            <button className="btn btn-hw-red w250" onClick={() => this.dsi() } >
                VISA
            </button>
        </div>
      </div>

      </div>
	;
	return html;
  };
}

export default Scr_TvDemo;
